import { Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import SettingNav from '../../../elements/SettingNav';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import { FilterComponent, NoRecordFound, PageLoader, Pagination, STableLoader } from '../../../../shared_elements';
import ProductAndServicesList from '../components/ProductAndServicesList';
import { globalGetService } from '../../../../utils/globalApiServices';
import { getProductService, getProductServiceCompanyNamesApi, getProductServiceList as getProductServiceListApi } from '../apiService';
import { checkApiStatus, setGlobalCookie } from '../../../../utils';
import { displayDateFormatShort } from '../../../../constants';
import moment from 'moment';
import { getQbStatusApi } from '../../../quickBooks/apiService';
import { trackActivity } from '../../../../utils/mixpanel';

const ProductAndServicesHD = ({ sortInfo, createSortHandler }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Product & Services`, page_type: page_type, })
    }
    const tableSorting = (key, name) => (
        <TableSortLabel
            active={sortInfo.sort === key}
            direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'}
            onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
        >
            {name}
        </TableSortLabel>
    );

    return (
        <TableHead>
            <TableRow>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>{tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>{tableSorting('company_name', 'Company Name')}</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>SKU</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>Type</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>Sales Description</TableCell>
            </TableRow>
        </TableHead>
    )
}

const ProductAndServices = () => {
    const [productServiceInfo, setProductServiceInfo] = useState({ list: [], pagination: {} });
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isQbEnabled, setIsQbEnabled] = useState(null);
    const [filter, setFilter] = useState({});
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [companyNames, setCompanyNames] = useState([]);

    useEffect(() => {
        globalGetService(getQbStatusApi()).then(response => {
            if (checkApiStatus(response)) {
                const enabled = response.data.data?.is_lessor_enabled;
                setIsQbEnabled(enabled);
                if (enabled) getProductServiceList('skeletonLoader', { per_page: 20 });
            } else {
                setIsQbEnabled(false);
            }
        });
        globalGetService(getProductServiceCompanyNamesApi()).then(response => {
            if (checkApiStatus(response)) {
                setCompanyNames(response.data.data || [])
            };
        });
        trackActivity('Page Viewed', { page_title: 'Product & Services' })
    }, []);

    const getProductServiceList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getProductServiceListApi(query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setProductServiceInfo(response.data.data);
            }
        });
    };

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' };
        } else {
            sortQuery = { ...sortQuery, sort_by: key === 'name' ? 'desc' : 'asc' };
        }
        setSortInfo(sortQuery);
        getProductServiceList('pageLoader', { ...filter, ...sortQuery, per_page: productServiceInfo?.pagination?.per_page || 20 });
    };

    const onApplyFilter = (query) => {
        setFilter(query);
        getProductServiceList('pageLoader', { ...query, page: 1, per_page: productServiceInfo?.pagination?.per_page || 20 });
    };

    const syncProductService = () => {
        setLoading(true);
        globalGetService(getProductService()).then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                setGlobalCookie('thirdPartyProductState', 'SyncProductFromQB');
                window.open(response.data.data.url, '_blank');
            }
        });
    };

    if (isQbEnabled === null) return <PageLoader />;

    if (!isQbEnabled) return (
        <div style={{ width: '100vw', height: '100vh', position: 'fixed' }}>
            <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#000000', textAlign: 'center', margin: '0 auto' }}>
                <br /><br />
                Sorry, You do not have access to the Page.<br />
                Please contact to Acumen for access<br />
                <Link to="/leases">Go Back</Link>
            </div>
        </div>
    );
    const filterOptions = {
        name: { title: 'Name', inputType: 'text' },
        company_name: { title: 'Company Name', inputType: 'dropdown', options: companyNames, valueKey: 'company_name', labelKey: 'company_name', multiple: false },
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Product & Services`, page_type: page_type, })
    }
    return (
        <Paper className="setting_details_section lease-details-section" elevation={0} sx={{ boxShadow: "0px 0px 2px 1px #BBBBBB" }}>
            {isLoading ? <PageLoader /> : null}
            <SettingNav />
            <div className="lease-details-content" >
                <Paper square className="responsive-paper">
                    <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                        <Grid item size={{ md: 8, xs: 12 }} className="menu-container">
                            <BackToLeaseList />
                            <FilterComponent
                                filter={filter}
                                filterMenu={filterOptions}
                                getResponseBack={onApplyFilter}
                            />
                            <Typography variant="h7" style={{ fontWeight: 'bold', color: '#9439e4', fontSize: '14px' }}> Last Synced by:{" "} <span style={{ fontSize: '12px', fontWeight: 'normal' }}> {productServiceInfo?.list?.[0]?.qb_last_sync_by?.name ? `${productServiceInfo.list[0]?.qb_last_sync_by.name} (${productServiceInfo.list[0]?.last_synced_at ? moment(productServiceInfo.list[0]?.last_synced_at).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>
                        </Grid>
                        <Grid item size={{ md: 4, xs: 12 }}>
                            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '5px' }}>
                                <li className='lease-mobile-button revision-history'>
                                    <Button variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { syncProductService(); handleItemClicked('Sync Product & Services') }}>Sync Product & Services</Button>
                                </li>
                            </ul>
                        </Grid>
                    </Grid>
                </Paper>
                <div className="lease-detail-table" square elevation={2}>
                    {skeletonLoader ? <STableLoader count={4} rowCount={12} /> : (
                        <Paper className='table-container' style={{ ...(productServiceInfo?.list?.length > 0
                            ? { height: 'calc(100vh - 240px)', maxHeight: 'none' }
                            : { height: 'auto', maxHeight: 'calc(100vh - 240px)' }
                        ) }}>
                            <Table className='mui-table-format' stickyHeader>
                                <ProductAndServicesHD sortInfo={sortInfo} createSortHandler={createSortHandler} />
                                <TableBody>
                                    {productServiceInfo?.list?.length > 0 && productServiceInfo?.list?.map((item) => (
                                        <ProductAndServicesList key={item.id} item={item} />
                                    ))}
                                </TableBody>
                            </Table>
                        </Paper>
                    )}
                    {!skeletonLoader && productServiceInfo?.list?.length === 0 && <NoRecordFound />}
                    <Paper>
                        <Pagination
                            pagination={productServiceInfo?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getProductServiceList('pageLoader', { ...filter, page: pageNum, per_page: productServiceInfo?.pagination?.per_page }); }}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getProductServiceList('pageLoader', { ...filter, page: 1, per_page: perPage }); }}
                        />
                    </Paper>
                </div>
            </div>
        </Paper>
    )
}

export default ProductAndServices
